<template>
	<div class="cms">
		<div v-if="!$store.getters.isLoggedIn" class="nep-dom_logo" @click.stop="$router.push('/')"><img :src="require('@/assets/img/logo_nep-dom.png')"/></div>
		<div v-else class="nep-dom_logo" @click.stop="$router.push('/')"><img :src="require('@/assets/img/logo_nep-dom.png')"/></div>

		<transition name="fade" mode="out-in">
			<set-password v-if="$store.getters.isLoggedIn && showSetPassword" :onceatime="$store.getters.getPasswordChange"/>
		</transition>

		<transition name="fade" mode="out-in">
			<forget-password v-if="!$store.getters.isLoggedIn && showPasswordForget && !showSetPassword" @backToLogin="showPasswordForget=false" />
		</transition>
		
		<transition name="fade" mode="out-in">
			<login v-show="!$store.getters.isLoggedIn && !showPasswordForget && !showSetPassword" @loggedIn="doLoadPins()" @showPasswordForget="showPassForget()"/>
		</transition>

		<transition name="fade" mode="out-in">
		<b-container v-if="$store.getters.isLoggedIn && !showPasswordForget && !showSetPassword" class="text-left prl-outside mt160">
		<b-row class="row-mobile">
			<b-col cols="12" class="p-0 mb-3 top-text">Pinnwand</b-col>
<!--
			<h5 class="fw800">INTRANET – WIE FUNKTIONIERT ES?</h5>
			<p>Bei deinem letzten Projekt hast du etwas Außergewöhnliches gesehen? Das Projekt hat dich total in den Bann gezogen und kann sich sehen lassen? Dann teile es mit deinen Kollegen.</p>
			<p>Eine <span class="fw800">Headline</span> zum Thema passend, ein <span class="fw800">Foto</span> und zwei bis drei Zeilen <span class="fw800">Text</span> und schon kann jeder Mitarbeiter daran teilhaben.<br>
			<span class="fw800">Macht alle mit – gemeinsam beleben wir unsere Pinnwand!</span></p>
 -->
			<b-col cols="12" class="p-0 top-new-item" @click="editNewPin()"> + Neuer Eintrag </b-col>
		</b-row>
		<b-row class="row-mobile">
			<b-col v-if="working" cols="12" class="m-0 text-center pb-2 bb-gera" style="height:auto;">
				<b-spinner variant="primary" class="mx-auto"></b-spinner>
			</b-col>
			<b-col :cols="12/columnsPerSite" class="p-1" v-for="(column,key) in pinsPerColumn" :key="key">
				<b-card class="p-0 mb-2" v-for="(article, akey) in column" :key="akey" style="background-color:#dcdcdc !important;">
					<div v-if="article.picture" class="w-100 float-left pb-1">
						<img class="w-100" :src="$store.getters.getDomain+'pictures/'+article.picture"/>
					</div>
					<div class="card-userpic">
						<img v-if="article.userpic" :src="$store.getters.getDomain+'pictures/'+article.userpic" class="w-100"/>
					</div>
					<div class="card-article-title">{{article.title}}</div>
					<div class="p-1 card-article-date">
						{{article.username}} am {{formatDate(article.date)}}
					</div>
					<div class="p-1 w-100 float-left" v-html="article.text">
					</div>
					<div class="card-toolbar pl-2 pr-2">
						<div class="article-like" @click="likePin(article)"><i class="fas fa-thumbs-up"></i></div>
						<span v-if="article.pinlikes.length>0 && !article.pinlikes.find(el => el.userid = article.userid)" class="fs08">{{article.pinlikes.length}}</span>
						<span v-if="article.pinlikes.length>0 && article.pinlikes.find(el => el.userid = article.userid)" class="fs08">Du{{(article.pinlikes.length>1)?' und '+(article.pinlikes.length-1)+' weitere':''}}</span>
						<div v-if="article.userid == userId || isAdmin" class="article-delete" @click="openModalDeletePin(article)"><i class="fas fa-trash"></i></div>
						<div v-if="article.userid == userId || isAdmin" class="article-edit" @click="editPinn(article)"><i class="fas fa-pen"></i></div>
					</div>
					<div v-for="(comment, ckey) in article.pincomments" :key="ckey" class="p-1 w-100 float-left comment bb-grey">
						<div class="float-left pr-1" style="width:18%"><img v-if="comment.userpic!==null" :src="$store.getters.getDomain+'pictures/'+comment.userpic" class="w-100"/></div>
						<div class="w-80 float-left">
							<div class="p-0 m-0 comment-text">{{comment.text}}</div>
						</div>
						<div class="p-0 m-0 comment-date">{{comment.username}} am {{formatDateTime(comment.date)}}</div>
						<div class="w-100 float-left">
							<div class="comment-like" @click="likePin(article, comment)"><i class="fas fa-thumbs-up"></i></div>
							<span v-if="comment.pincommentslikes.length>0 && !comment.pincommentslikes.find(el => el.userid = comment.userid)" class="fs08">{{comment.pincommentslikes.length}}</span>
							<span v-if="comment.pincommentslikes.length>0 && comment.pincommentslikes.find(el => el.userid = comment.userid)" class="fs08">Du{{(comment.pincommentslikes.length>1)?' und '+(comment.pincommentslikes.length-1)+' weitere':''}}</span>
							<div v-if="comment.userid == userId || isAdmin" class="article-delete float-right cl-white cursorp" @click="openModalDeleteComment(article, comment)"><i class="fas fa-trash"></i></div>
						</div>
					</div>
					<div class="p-1 comment w-100 float-left" :class="(article.pincomments)?'bb-grey;':''">
						<div class="w-20 float-left" v-if="userData.userpic!==null"><img :src="$store.getters.getDomain+'pictures/'+userData.userpic" style="width:30px;"/></div>
						<div class="float-left" :class="(userData.userpic!==null)?'w-80':'w-100'"><b-form-input size="sm" type="text" v-model="article.pincomment" placeholder="Kommentieren" @keyup.enter="addPinComment(article)"></b-form-input></div>
					</div>
				</b-card>
			</b-col>
		</b-row>
		</b-container>
		</transition>
		<div class="big-text text-left">{{(!$store.getters.isLoggedIn)?((!showPasswordForget)?$t('login'):$t('pass-forget')):'Pinnwand'}}</div>

		<app-modal :width="(width<768)?'90%':'50%'" @closeModal="editModalShow=false" v-show="editModalShow">
			<div slot="title">
				{{(editPin.id==0)?'Neuer Eintrag':'Eintrag bearbeiten'}}
			</div>
			<div slot="content" class="text-left">
				<b-form-group id="input-group-1" label="Titel:" label-for="title">
					<b-form-input
					id="title"
					size="sm"
					v-model="editPin.title"
					required
					placeholder="Titel eingeben"
					></b-form-input>
				</b-form-group>
				<b-form-group id="input-group-2" label="Inhalt:" label-for="text">
					<b-col sm="12" class="p-0">
					<b-form-textarea
						id="text"
						size="sm"
						rows="6"
						v-model="editPin.text"
						placeholder="Inhalt eingeben"	
					></b-form-textarea>
					</b-col>
				</b-form-group>
				<b-form-group id="input-group-3" label="Links:" label-for="links">
					<b-col sm="12" class="p-0">
					<b-form-textarea
						id="links"
						size="sm"
						v-model="editPin.links"
						placeholder="Links eingeben"
					></b-form-textarea>
					</b-col>
				</b-form-group>
				<b-form-group :label="(!editPin.picture)?'Bild hochladen:':'Bild:'" label-for="file">
					<b-form-file v-show="!editPin.picture && !url"
						name="file"
						size="sm"
						v-model="editPin.file"
						accept=".png, .jpg, .jpeg"
						placeholder="Foto hochladen (oder legen Sie sie hier ab...)"
						drop-placeholder="Datei hier ablegen..."
						@change="onFileChange"
					></b-form-file>

					<b-col v-if="(!url && editPin.picture)" sm="3" name="picture" style="position:relative;">
						<img :src="$store.getters.getDomain+'pictures/'+editPin.picture" style="width:100%;">
						<div class="remove-picture" @click="removePicture()"><i class="fas fa-times fa-6x"></i></div>
					</b-col>

					<b-col v-if="url" sm="3" name="picture" style="position:relative;">
						<img :src="url" style="width:100%;">
						<div class="remove-picture" @click="removePicture()"><i class="fas fa-times fa-6x"></i></div>
					</b-col>
				</b-form-group>
			</div>
			<div slot="buttons-left" style="display:none;">
				<b-button size="sm" class="btn-cancel text-center" style="font-weight:800 !important;width:320px;color:white !important;background-color:darkred !important;border:solid 1px darkred !important;cursor:default;">
					FEHLER!!!! Bild ist zu groß!
				</b-button>
			</div>
			<div slot="buttons-right">
				<b-button size="sm" class="btn-cancel" @click="editModalShow=false">
					Abbrechen
				</b-button>
				<b-button size="sm" class="btn-confirm" @click="savePin()">
					Speichern
				</b-button>
			</div>
		</app-modal>
		<app-modal width="350px" @closeModal="deletePinModalShow=false" v-show="deletePinModalShow">
			<div slot="title">
				<div class="float-left"><i class="fas fa-question-circle fa-2x"></i></div><div class="float-left ml-2 modal-header-text">Pin löschen?</div>
			</div>
			<div slot="content" class="text-left bb-gera"></div>
			<div slot="buttons-right">
				<b-button class="btn-cancel" size="sm" @click="deletePinModalShow=false">Abbrechen</b-button>
				<b-button class="btn-confirm" size="sm" @click="deletePin()">Löschen</b-button>
			</div>
			</app-modal>
			<app-modal width="350px" @closeModal="deleteCommentModalShow=false" v-show="deleteCommentModalShow">
			<div slot="title">
				<div class="float-left"><i class="fas fa-question-circle fa-2x"></i></div><div class="float-left ml-2 modal-header-text">Kommentar löschen?</div>
			</div>
			<div slot="content" class="text-left bb-gera"></div>
			<div slot="buttons-right">
				<b-button class="btn-cancel" size="sm" @click="deleteCommentModalShow=false">Abbrechen</b-button>
				<b-button class="btn-confirm" size="sm" @click="deletePinComment()">Löschen</b-button>
			</div>
		</app-modal>
	</div>
</template>

<script>
import store from '@/store';
import api from '@/components/backend-api'
import appModal from '@/components/Modal.vue';
import login from '@/components/intranet/Login.vue';
import forgetPassword from '@/components/intranet/ForgetPassword.vue';
import setPassword from '@/components/intranet/SetPassword.vue';
export default {
	name: 'cms',
	components: {
		appModal,
		login,
		forgetPassword,
		setPassword
	},
	data () {
		return {
			working: false,
			url: null,
			editPin: {
				id: 0,
				title: '',
				text: '',
				links: '',
				picture: null
			},
			editModalShow: false,
			deletePinModalShow: false,
			pin4delete: null,
			deleteCommentModalShow: false,
			comment4delete: null,
			showPasswordForget: false,
			// showSetPassword: false,
			error: false,
			errors: [],
			columnsPerSite: 4,
			pins: [],
			width: 1200
		}
	},
	methods: {
		formatDate (sDate) {
			if (!sDate) return '';
			let date = new Date(sDate);
			return date.toLocaleDateString('de-DE')
		},
		formatDateTime (sDate) {
			if (!sDate) return '';
			let date = new Date(sDate);
			return date.toLocaleString('de-DE')
		},
		doLoadPins () {
			// console.log('DO Load Pins! NOW!!!');
			this.working = true;
			const now = new Date();
			let loadPinData =  {
				'dateFrom': '2010-06-01T00:00:00.000Z',
				'dateTo': now.toISOString(),
				'fromNb': 0,
				'pinsToLoad': 0
			}
			let modal = this.$store.state.modal;
			api.executePostServerAction('/user/loadPins', loadPinData, true)
				.then(response => {
					this.working = false;
					// console.log('Response:');
					// console.log(response);
					this.pins = response.data;
				})
				.catch(error => {
					this.working = false;
					console.log('Load pins error!');
					console.log('Error: ' + error);
					console.log(error.response);

                if (error.response !== undefined){
                    modal.message = error.response.data.message;
                    modal.color = 'color:darkred !important';
                    modal.type = 'warning';
                    modal.show = true;
                    if (error.response.status==400){
                        // this.$store.dispatch('logout');
                        // this.$router.push('/intranet');
                    }
                } else {
                    modal.message = error;
                    modal.color = 'color:darkred !important';
                    modal.type = 'warning';
                    modal.show = true;
                }
			})
		},
		editNewPin () {
			this.editPin = {
				id: 0,
				title: '',
				text: '',
				links: '',
				picture: null,
				file: null,
				type: 'new'
			},
			this.editModalShow = true;  	
		},
		editPinn (pin) {
			this.editPin = {
				id: pin.id,
				title: pin.title,
				text: pin.text,
		//      	links: pin.links,
				picture: pin.picture,
				file: null,
				type: 'update'
			},
			this.editModalShow = true;  	
		},
		savePin () {
			// console.log('Save memo data!');
			let fd = new FormData();

			let now = new Date();
			let user = this.$store.getters.getUserData;

			fd.append('userid', user.userId);
			fd.append('date', now.toISOString());
			fd.append('title', this.editPin.title);
			fd.append('text', this.editPin.text);
			fd.append('links', this.editPin.links);
			if (this.editPin.type==='update') fd.append('id', this.editPin.id);
			if (this.editPin.file) fd.append('file',this.editPin.file);

	        let modal = this.$store.state.modal;
			api.executePostServerAction('/user/savePin', fd, true, true)
				.then(response => {
					// console.log('Save pin Response:');
					// console.log(response);
					this.editModalShow=false;
					this.doLoadPins();
				})
				.catch(error => {
					console.log('Save pin error!');
					console.log('Error: ' + error);
					console.log(error.response);

					if (error.response !== undefined){
						modal.message = error.response.data.message;
						modal.color = 'color:darkred !important';
						modal.type = 'warning';
						modal.show = true;
						if (error.response.status==400){
							// this.$store.dispatch('logout');
							// this.$router.push('/intranet');
						}
					} else {
						modal.message = error;
						modal.color = 'color:darkred !important';
						modal.type = 'warning';
						modal.show = true;
					}
				})
		},
		onFileChange (e) {
			const file = e.target.files[0];
			this.url = URL.createObjectURL(file);
		},
		removePicture () {
			if (this.url){
				this.url = null;
				this.editPin.picture = null;
				return false
			} 
			if (this.editPin.picture) {
				this.editPin.picture = null;
			}
		},
		removePicture () {
			this.editPin.picture = null;
		},
		likePin (pin, comment = null) {
			// check if 
			let now = new Date();
			let user = this.$store.getters.getUserData;
			let likeData = {
				date: now.toISOString(),
				pinid: pin.id,
				userid: user.userId
			}
			let action = '/user/savePinlikes';
			if (!comment){
				// like / unlike pin
				console.log('Like pin: '+pin.title+' ('+pin.id+')');
				if (pin.pinlikes.length>0 && pin.pinlikes.find(el => el.userid = pin.userid)){
					action = '/user/deletePinlikes'
					let like = pin.pinlikes.find(el => el.userid = pin.userid);
					likeData.id = like.id
				}
			} else {
				// like / unlike pin
				console.log('Like pin comment: '+comment.title+' ('+comment.id+')');
				likeData.pincommentsid =  comment.id
				if (comment.pincommentslikes.length>0 && comment.pincommentslikes.find(el => el.userid = comment.userid)){
					action = '/user/deletePinlikes';
					let like = comment.pincommentslikes.find(el => el.userid = comment.userid);
					likeData.id = like.id
				}
			}
			let modal = this.$store.state.modal;
			api.executePostServerAction(action, likeData, true)
				.then(response => {
					if (!comment){
						console.log('Like/unlike pin Response:');
					} else {
						console.log('Like/unlike pin comment Response:');
					}
					console.log(response);
					// this.pins = response.data;
					this.doLoadPins();
				})
				.catch(error => {
					console.log('Like pin error!');
					console.log('Error: ' + error);
					console.log(error.response);
					if (error.response !== undefined){
						modal.message = error.response.data.message;
						modal.color = 'color:darkred !important';
						modal.type = 'warning';
						modal.show = true;
						if (error.response.status==400){
							// this.$store.dispatch('logout');
							// this.$router.push('/intranet');
						}
					} else {
						modal.message = error;
						modal.color = 'color:darkred !important';
						modal.type = 'warning';
						modal.show = true;
					}
				})
		},
		addPinComment (pin) {
			console.log('Like pin: '+pin.title+' ('+pin.id+')');
			let now = new Date();
			let user = this.$store.getters.getUserData;
			let commentData = {
				date: now.toISOString(),
				pinid: pin.id,
				userid: user.userId,
				text: pin.pincomment
			}
			let modal = this.$store.state.modal;
			api.executePostServerAction('/user/savePincomments', commentData, true)
				.then(response => {
					console.log('Add pin comment Response:');
					console.log(response);

					// this.pins = response.data;
					this.doLoadPins();
				})
				.catch(error => {
					console.log('Add pin Comment error!');
					console.log('Error: ' + error);
					console.log(error.response);
					if (error.response !== undefined){
						modal.message = error.response.data.message;
						modal.color = 'color:darkred !important';
						modal.type = 'warning';
						modal.show = true;
						if (error.response.status==400){
							// this.$store.dispatch('logout');
							// this.$router.push('/intranet');
						}
					} else {
						modal.message = error;
						modal.color = 'color:darkred !important';
						modal.type = 'warning';
						modal.show = true;
					}
				})
		},
		openModalDeletePin (pin) {
			this.deletePinModalShow = true;
			let now = new Date();
			let user = this.$store.getters.getUserData;
			let deletePinData = {
				date: now.toISOString(),
				id: pin.id,
				userid: user.userId
			}
			this.pin4delete = deletePinData;
		},
		deletePin () {
			let modal = this.$store.state.modal;
			api.executePostServerAction('/user/deletePin', this.pin4delete, true)
				.then(response => {
					this.deletePinModalShow = false;
					this.pin4delete = null;
					console.log('Delete pin Response:');
					console.log(response);

					// this.pins = response.data;
					this.doLoadPins();
				})
				.catch(error => {
					this.deletePinModalShow = false;
					console.log('Like pin error!');
					console.log('Error: ' + error);
					console.log(error.response);
					if (error.response !== undefined){
						modal.message = error.response.data.message;
						modal.color = 'color:darkred !important';
						modal.type = 'warning';
						modal.show = true;
						if (error.response.status==400){
							// this.$store.dispatch('logout');
							// this.$router.push('/intranet');
						}
					} else {
						modal.message = error;
						modal.color = 'color:darkred !important';
						modal.type = 'warning';
						modal.show = true;
					}
				})
		},
		openModalDeleteComment (pin, comment) {
			this.deleteCommentModalShow = true;

			let now = new Date();
			let user = this.$store.getters.getUserData;
			let deleteCommentData = {
				date: now.toISOString(),
				pinid: pin.id,
				id: comment.id,
				userid: user.userId
			}
			this.comment4delete = deleteCommentData;
		},
		deletePinComment(pin, comment) {
			let modal = this.$store.state.modal;
			api.executePostServerAction('/user/deletePincomments', this.comment4delete, true)
				.then(response => {
					this.deleteCommentModalShow = false;
					console.log('Delete comment Response:');
					console.log(response);
					// this.pins = response.data;
					this.doLoadPins();
				})
				.catch(error => {
					this.deleteCommentModalShow = false;
					console.log('Delete commant error!');
					console.log('Error: ' + error);
					console.log(error.response);
					if (error.response !== undefined){
						modal.message = error.response.data.message;
						modal.color = 'color:darkred !important';
						modal.type = 'warning';
						modal.show = true;
						if (error.response.status==400){
							// this.$store.dispatch('logout');
							// this.$router.push('/intranet');
						}
					} else {
						modal.message = error;
						modal.color = 'color:darkred !important';
						modal.type = 'warning';
						modal.show = true;
					}
				})
		},
		showPassForget () {
			this.$store.dispatch('resetBadLogin');
			this.showPasswordForget=true;
		},
		setColumnsPerSite () {
			const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
			this.width = vw;
			let cps = 4;
			if (vw <= 480) {
				cps = 1
			} else if (vw>480 && vw<=768) {
				cps = 2
			} else if (vw>768 && vw<=1020) {
				cps = 3
			} else {
				cps = 4
			}

			if (cps == this.columnsPerSite) return false;

			this.columnsPerSite = cps;
			
			this.$nextTick(() => {
				this.$forceUpdate()
			})
		}
	},
	created () {
		this.setColumnsPerSite()
		window.addEventListener('resize', () => {
		this.setColumnsPerSite();
		})
	},
	mounted () {
		if (this.loggedIn){
			// this.doLoadPins();
		}
	//	if (this.$store.getters.getPasswordChange){
	//		this.showSetPassword = true
	//	}
	},
	computed: {
		showSetPassword() {
			return this.$store.getters.getPasswordChange
		},
		accessToken() {
			return this.$store.getters.getToken
		}, 
		loggedIn () {
			return this.$store.getters.isLoggedIn
		},
		loginError () {
			return this.$store.getters.hasLoginErrored
		},
		loginErrorText () {
			return this.$store.getters.getLoginErrorText
		},
		userId () {
			let user = this.$store.getters.getUserData;
			return user.userId;
		},
		userData () {
			return store.getters.getUserData;
		},
		pinsPerColumn () {
			let columns = [];
			for (let i = 0; i < this.columnsPerSite; i++) {
				columns[i] = [];
			}
			let column = 0;
			this.pins.forEach((pin) => {
				columns[column].push(pin);
				column = column + 1;
				if (column > this.columnsPerSite-1) column = 0;
			})
			return columns
		},
		isAdmin () {
			let roles = this.$store.getters.getUserRoles
			return roles.includes('ADMIN')
		}
	}
}
</script>
<style>
	.card {
		border: none !important;
		background-color: #eee !important;
	}
	.card-body {
		padding: 0.25rem !important;
	}
	.top-new-item {
		color:#307bad;
		cursor:pointer;
		border-bottom:solid 1px #307bad;
		padding-bottom:15px !important;
		margin-bottom:15px !important;
	}
	.card-userpic {
		float:left;width:18%; margin-right:2%;
	}
	.card-article-title {
		float:left;max-width:80%;font-size:1.2em;font-weight:700;padding-top:0;line-height: 1.4;
		/* white-space: nowrap;overflow: hidden;text-overflow: ellipsis; */
	}
	.card-article-date {
		float:left;width:100%;font-weight:100;font-size:0.8em;
	}
	.card-toolbar {
		width:100%;float:left; border-bottom:solid 1px grey;
	}
	.card-toolbar .article-like {
		float:left;color:white;cursor:pointer;margin-right:8px;
	}
	.card-toolbar .article-delete {
		float:right;color:white;cursor:pointer;
	}
	.card-toolbar .article-edit {
		float:right;color:white;cursor:pointer;margin-right:8px;
	}
	.comment-text {
		float:left;max-width:100%;font-size:1em;padding-top:10px;
	}
	.comment-date {
		float:left;width:100%;font-size:0.7em;
	}
	.comment-like {
		float:left;color:white;cursor:pointer;margin-right:5px;
	}
	.remove-picture {
		position: absolute;
		top: -4px;
		left: 26px;
		opacity: 0.7;
		z-index: 2;
		color: grey;
		cursor: pointer;
		font-size: 19px;
	}
</style>
<i18n>
	{
		"sl": {
			"login": "Prijava",
			"username": "Uporabniško ime",
			"password": "Geslo",
			"username-enter": "Vpišite uporabniško ime",
			"password-enter": "Vpišite geslo",
			"pass-forget": "Pozabil sem geslo",
			"remember-me": "zapomni si prijavo"
		},
		"de": {
			"login": "Anmeldung",
			"username": "Benutzername",
			"password": "Passwort",
			"username-enter": "Benutzername eingeben",
			"password-enter": "Passwort eingeben",
			"pass-forget": "Passwort vergessen",
			"remember-me": "Angemeldet bleiben"
		},
		"en": {
			"login": "Login",
			"username": "Username",
			"password": "Password",
			"username-enter": "Enter username",
			"password-enter": "Enter password",
			"pass-forget": "Forgot password",
			"remember-me": "Remember me"
		}
	}
</i18n>
